import { render, staticRenderFns } from "./FertilizationCompanies.html?vue&type=template&id=52cdc790&external"
import script from "./FertilizationCompanies.js?vue&type=script&lang=js&external"
export * from "./FertilizationCompanies.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports